export default "__VITE_ASSET__DXY5u$3Q__"